<div>
  <anms-trends></anms-trends>
</div>
